import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChatIcon from '@mui/icons-material/Chat';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Badge } from '@mui/material';
import { LoginType } from '../types/LoginType';
import { api, apiUrl } from '../services/api';
import NotificationsMenu from './NotificationsMenu';
import { Notifications } from './NotificationType';
import { isPermite } from '../utilities/isPermite';
import { useChat } from '../components/Chat/ChatProvider';

interface HeaderProps {
    onDrawerToggle: () => void;
    infoLogin: LoginType
}

export default function Header(props: HeaderProps) {
    const { onDrawerToggle, infoLogin } = props;
    const firstName = String(infoLogin.nome_usuario).split(" ");
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [anchorNot, setAnchorNot] = React.useState<null | HTMLElement>(null);
    const [notifications, setNotifications] = useState<Notifications[]>([]);
    const [notificationCount, setNotificationCount] = useState(0);
    const { habilitado: chatHabilitado, totalNaoLidas, alternarChat } = useChat();

    const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleProfile = () => {
        navigate("/profile");
    }

    const logout = () => {
        sessionStorage.removeItem('infoLogin');
        navigate("/login");
    }

    async function fetchNotifications() {
        const permite = isPermite("37");
        if (permite) {
            try {
                const response = await api.get(`/notifications`);
                if (!response.data.error && response.data[0]) {
                    setNotifications(response.data);
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        if (notifications.length > 0) {
            const ct = notifications.filter(i => Number(i.is_read) === 0);
            setNotificationCount(ct.length);
        }
    }, [notifications]);

    useEffect(() => {
        fetchNotifications();
    }, []);

    return (
        <React.Fragment>
            <AppBar color="primary" position="sticky" elevation={0}>
                <NotificationsMenu
                    anchorEl={anchorNot}
                    setAnchorEl={setAnchorNot}
                    notifications={notifications}
                    setNotification={setNotifications}
                />
                <Toolbar>
                    <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                        <Grid sx={{ display: { sm: 'none', xs: 'block' } }} item>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={onDrawerToggle}
                                edge="start"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Grid>
                        <Grid item sx={{ display: { sm: 'block', xs: 'none' } }}>
                            <Typography color="inherit" variant="h5" component="h2">
                                {infoLogin.nome_escritorio}
                            </Typography>
                        </Grid>
                        <Grid item>
                            {chatHabilitado && (
                                <Tooltip title="Chat Interno" sx={{ marginRight: 1 }}>
                                    <IconButton color="inherit" onClick={alternarChat}>
                                        <Badge badgeContent={totalNaoLidas} color="error" max={99}>
                                            <ChatIcon />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                            )}
                            <Tooltip title="Notificações" sx={{ marginRight: 1 }}>
                                <IconButton
                                    color="inherit"
                                    onClick={e => {
                                        if (notifications.length > 0) setAnchorNot(e.currentTarget);
                                    }}
                                >
                                    <Badge badgeContent={notificationCount} color="secondary" max={99}>
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                            <IconButton color="inherit" sx={{ p: 0.5, gap: 1 }} onClick={handleMenu}>
                                <Avatar
                                    src={String(infoLogin.photo_usuario).length > 0 ? `${apiUrl}/userProfile/${infoLogin.photo_usuario}` : ""}
                                    alt={firstName[0]}
                                />
                                <Typography color="inherit" variant="h6" component="h4" sx={{ display: { sm: 'block', xs: 'none' } }}>
                                    {firstName[0]}
                                </Typography>
                            </IconButton>

                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleCloseMenu}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={handleProfile}>
                                    <ListItemIcon>
                                        <AccountCircleIcon fontSize="small" color='primary' />
                                    </ListItemIcon>
                                    <ListItemText>Perfil</ListItemText>
                                </MenuItem>
                                <MenuItem onClick={logout}>
                                    <ListItemIcon>
                                        <LogoutIcon fontSize="small" color='primary' />
                                    </ListItemIcon>
                                    <ListItemText>Logout</ListItemText>
                                </MenuItem>
                            </Menu>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}